var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';
import * as i0 from "@angular/core";
var defaultSortParam = 'infraccion';
var defaultSortDirection = 'asc';
var LocalizacionFilterService = /** @class */ (function (_super) {
    __extends(LocalizacionFilterService, _super);
    function LocalizacionFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalizacionFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        return new HttpParams()
            .append('vel_via', filter.vel_via === null ? null : filter.vel_via.toString())
            .append('infraccion', filter.infraccion === null ? null : filter.infraccion.toString())
            .append('propuesta', filter.propuesta ? filter.propuesta : '')
            .append('cod_aparat', filter.cod_aparat ? filter.cod_aparat : '')
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    LocalizacionFilterService.ngInjectableDef = i0.defineInjectable({ factory: function LocalizacionFilterService_Factory() { return new LocalizacionFilterService(); }, token: LocalizacionFilterService, providedIn: "root" });
    return LocalizacionFilterService;
}(CustomFilterService));
export { LocalizacionFilterService };
